import { TeamSizeDropdownProps } from "./team-size-dropdown.types";
import { getTeamSizeOptions } from "./team-size-dropdown.utils";
import { ValidatedDropdown } from "../validated-dropdown";

export const TeamSizeDropdown = <T,>(props: TeamSizeDropdownProps<T>) => {
	return <ValidatedDropdown {...props} options={getTeamSizeOptions()} />;
};
